export const sectionCodeList = [
  { id: "", name: "All" },
  { id: "143(3)", name: "143(3)" },
  { id: "144", name: "144" },
  { id: "147", name: "147" },
  { id: "272A(1)(d)", name: "272A(1)(d)" },
  { id: "115_WE", name: "115_WE" },
  { id: "1431a", name: "1431a" },
  { id: "154", name: "154" },
  { id: "1433", name: "1433" },
  { id: "271B", name: "271B" },
  { id: "271F", name: "271F" },
  { id: "139(9)", name: "139(9)" },
  { id: "u/s 139(9)", name: "u/s 139(9)" },
  { id: "271(1)(c)", name: "271(1)(c)" },
  { id: "272A(1)(d)", name: "272A(1)(d)" },
  { id: "270A", name: "270A" },
  { id: "250", name: "250" },
  { id: "142(1)", name: "142(1)" },
  { id: "148", name: "148" },
  { id: "143(1)(a)", name: "143(1)(a)" },
];

export const getAutFinancialYears = () => {
  let fiscalYears: string[] = [];
  for (let i = 0; i < 1; i++) {
    const year = new Date().getFullYear() + i + 1;
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.unshift(fiscalYear);
  }
  for (let i = 0; i < 25; i++) {
    const year = new Date().getFullYear() - i;
    const fiscalYear = `${year}-${(year + 1).toString().slice(-2)}`;
    fiscalYears.push(fiscalYear);
  }

  return fiscalYears;
};

export const clientCategories = [
  { value: "individual", label: "Individual" },
  { value: "huf", label: "Hindu Undivided Family" },
  { value: "partnership_firm", label: "Partnership Firm" },
  { value: "llp", label: "Limited Liability Partnership" },
  { value: "company", label: "Company" },
  { value: "aop", label: "Association of Persons" },
  { value: "boi", label: "Body of Individuals" },
  { value: "trust", label: "Trust" },
  { value: "government", label: "Government" },
  { value: "local_authority", label: "Local Authority" },
  { value: "artificial_judicial_person", label: "Artificial Juridical Person" },
];

export const sortFilter = [
  { value: "AMOUNT_DESC", label: "Amount High" },
  { value: "AMOUNT_ASC", label: "Amount Low" },
  { value: "DATE_NEWEST", label: "Date Newest" },
  { value: "DATE_OLDEST", label: "Date Oldest" },
];

export const incomeTaxFormsFilingTypes = {
  Original: "Original",
  Revised: "Revised",
};

export const incomeTaxForms = [
  "Form 5BA",
  "Form 10BBC",
  "Form 10BC",
  "Form 10CCB",
  "Foem 10-IJ",
  "Form 10-IL",
  "Form 15CA",
  "Form 15CB",
  "Form 15CD",
  "Form 15G",
  "Form 15H",
  "Form 24Q",
  "Form 26Q",
  "Form 26A",
  "Form 27BA",
  "Form 27C",
  "Form 27Q",
  "Form 27EQ",
  "Form 34BC",
  "Form 35",
];

export function calculateAssessmentYear(startYear) {
  const endYear = parseInt(startYear) + 1;
  return startYear + "-" + endYear.toString().slice(2);
}

export const getGstrFinancialYears = () => {
  let fiscalYears: string[] = [];
  for (let i = 0; i < 1; i++) {
    const year = new Date().getFullYear() + i + 1;
    const fiscalYear = `${year}-${(year + 1).toString()}`;
    fiscalYears.unshift(fiscalYear);
  }
  for (let i = 0; i < 9; i++) {
    const year = new Date().getFullYear() - i;
    const fiscalYear = `${year}-${(year + 1).toString()}`;
    fiscalYears.push(fiscalYear);
  }

  return fiscalYears;
};

export const textBgColors = [
  { bg: "#FFEDE0", txt: "#F7964F" },
  { bg: "#FFECED", txt: "#EE363C" },
  { bg: "#F1EAFF", txt: "#673AB8" },
  { bg: "#CEE9FF", txt: "#266396" },
  { bg: "#FFE4EF", txt: "#91305a" },
  { bg: "#E1DDFF", txt: "#695EB3" },
  { bg: "#DADEFF", txt: "#455aff" },
  { bg: "#E4F0FF", txt: "#7DA6DC" },
  { bg: "#D8FFCC", txt: "#0E3601" },
  { bg: "#FFF2CF", txt: "#FCbF1B" },
  { bg: "#FFDBCD", txt: "#f54907" },
  { bg: "#FFD5EC", txt: "#f6bfq1b" },
  { bg: "#FFE1D8", txt: "#b04b2a" },
];

export const challanPaymentTax = [
  { value: "Other Receipts", label: "Other Receipts (500)" },
  {
    value: "Outstanding Demand (Regular Assessment Tax)",
    label: "Outstanding Demand (Regular Assessment Tax) (400)",
  },
  { value: "TDS on Sale of Property", label: "TDS on Sale of Property (800)" },
  { value: "Self-Assessment Tax", label: "Self-Assessment Tax (300)" },
  { value: "Advance Tax", label: "Advance Tax (100)" },
];

export const udinFormStats = {
  UDIN_APPLICABLE: "UDIN Applicable",
  UDIN_NOT_APPLICABLE: "UDIN Not Applicable",
  UDIN_COMPLETED: "UDIN Completed",
  UDIN_PENDING: "UDIN Pending",
};

export const formFilingStatus = [
  { value: "Filed", label: "Filed" },
  { value: "Not Filed", label: "Not Filed" },
];

export const tanFormStats = ["Original/Regular", "Revised/Correction"];

export const getCurrentFinancialYear = (date) => {
  // const givenDate = new Date(date);
  // const year = givenDate.getFullYear();
  // const month = givenDate.getMonth()+1;

  // const financialYearStart = month < 4 ? year - 1 : year;
  // const financialYearEnd = financialYearStart + 1;

  // return financialYearStart;
  const givenDate = new Date(date);
  const year = givenDate.getFullYear();
  const month = givenDate.getMonth() + 1;

  if (month <= 6) {
    return year - 1;
  } else {
    return year;
  }
};

export const getCurrentQuarter = (date) => {
  const month = date.getMonth();
  if (month < 3) return "Q4"; // Jan-Mar -> Q4
  if (month < 6) return "Q1"; // Apr-Jun -> Q1
  if (month < 9) return "Q2"; // Jul-Sep -> Q2
  return "Q3";
};

export const getCurrentAssessmntYear = () => {
  const givenDate = new Date();
  const year = givenDate.getFullYear();

  return year.toString();
};

export const tanTracesTypes = ["Required", "Not Required"];

export const tracesFormTypes = [
  "5BA",
  "10BBC",
  "10BC",
  "10CCB",
  "10-IJ",
  "10-IL",
  "15CA",
  "15CB",
  "15CD",
  "15G",
  "15H",
  "24Q",
  "26Q",
  "26A",
  "27BA",
  "27C",
  "27Q",
  "27EQ",
  "34BC",
  "35",
];
